import {randomKey} from 'common/src/utils/commonUtils';
import icons from 'common/src/components/Copilot/Copilot.icons';
import {ConversationStarter} from './copilot.types';

const interactionCancelledMessageText = 'Operation cancelled';

const FORCE_HIDE_COPILOT_SEARCH_PARAM = 'hideCopilot';

const ragSimilarityThreshold = 0.5;

const ragNumberOfResults = 3;

const copilotSliceKey = 'copilot';

const xlsIconColor = '#18884F';

const maxConversationStarters = 5;

const generalConversationStarter: ConversationStarter = {
  key: randomKey(),
  displayName: 'Ask About Flight Control',
  prompt: 'How does the product handle...',
  icon: {
    src: icons.questionMark,
    color: '#9100B4',
  },
};

export {
  copilotSliceKey,
  interactionCancelledMessageText,
  FORCE_HIDE_COPILOT_SEARCH_PARAM,
  ragNumberOfResults,
  ragSimilarityThreshold,
  xlsIconColor,
  generalConversationStarter,
  maxConversationStarters,
};
